"use client";

import React, { useState, useEffect, useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { useToast } from '@/components/ui/use-toast';
import LocationAutocomplete from './LocationAutocomplete';

import type { NoteLocation } from '@/types/location';

interface LocationInputProps {
  value: NoteLocation | null;
  onChange: (location: NoteLocation | null) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  forceBlank?: boolean;
  showLabel?: boolean;
}

const LocationInput: React.FC<LocationInputProps> = ({ value, onChange, disabled, autoFocus, forceBlank, showLabel }) => {
  const [loadingGeolocation, setLoadingGeolocation] = useState(false);
  const { toast } = useToast();

  const reverseGeocode = useCallback(async (lat: number, lon: number): Promise<string | null> => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`,
        { mode: 'cors' }
      );
      if (!response.ok) throw new Error('Failed to fetch reverse geocode');
      const data = await response.json();
      
      if (data.display_name) {
        return data.display_name;
      }
      console.warn("[NOMINATIM] Success, but no display_name found in response.", data);
      return null;
    } catch (error) {
      console.error("[NOMINATIM] Error during reverse geocode:", error);
      return null;
    }
  }, []);

  

  return (
    <div className="grid gap-2">
      {showLabel !== false && <Label htmlFor="note-location">Ubicación (opcional)</Label>}
      <div className="flex items-start space-x-2">
        <div className="relative flex-1">
          <LocationAutocomplete
            value={value}
            onChange={onChange}
            disabled={disabled || loadingGeolocation}
            autoFocus={Boolean(autoFocus) && !(disabled || loadingGeolocation)}
            forceBlank={Boolean(forceBlank)}
            placeholder="Escribe una ubicación (ej. Neuquén Capital)"
          />
        </div>
        {/* GPS and clear buttons removed per UX request */}
      </div>
    </div>
  );
};

export default LocationInput;